<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="col-md-3"></div>
            <div class="col-md-6">
            <div>
                <div class="box-header">
                    <h3 class="box-title">Update Destination</h3>
                </div>
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details">
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <label>Trip Code</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="form-control"> {{ trip.tripCode }} </label>
                                </div>
                            </div><br><br>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <label>Present Destination</label>
                                </div>
                                <div class="col-sm-6">
                                   <label class="form-control">{{ trip.endSiteSiteName}} </label>
                                </div>
                            </div><br><br>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <label> New Destination </label>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.endSite)">
                                    <select v-model="tripException.divertedDestination" required name="divertedDestination" class="form-control">
                                        <option disabled>Select Location</option>
                                        <option v-for="(item,index) in site_name" :key="index" :value="item.key">
                                            {{item.value}}
                                        </option>
                                    </select>
                                    <field-messages name="endSite" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is a required field</div>
                                    </field-messages>
                                    </validate>
                                </div>
                            </div><br><br>
                        </vue-form>
                        <br><br>
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'Trip' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                            <button class="mr-2 btn gradientbt" type="submit" @click="updateTrip" :disabled="!(formstate.$dirty && formstate.$valid)">Update</button>
                        </div> 
                    </div>
                </div>
            </div>
            </div>
        </div>
    </section>
</template>

<script>
import { formService, eventBus , tripService ,tripExceptionService } from '../../../services';
import { EVENTS } from '../../../config';

export default {
    name:'UpdateDestination',
    data (){
        return {
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            site_name : '',
            trip : {
                status : 'active'
            },
            tripException : {
                prevDestination : '',
                docId : ''
            },
            trip : {

            }
        }
        
    },
    mounted(){
        this.getTrip()
        this.getSite()
    },
    methods:{
        fieldClassName: formService.fieldClassName,
        getTrip() {
            return this.$tripDataRepository.find(this.$route.params._id)
            .then((response) => {
                this.tripException.prevDestination = response.data.endSite;
                this.endSite = response.data.endSite
                this.tripException.docId = response.data._id
                console.log("prevDestination",this.tripException.prevDestination)
                console.log("id is ",  this.tripException.docId)
                this.trip = response.data;
                console.log(  "...",this.trip)
            })
            .catch((error) => {
                this.$snotify.error(' OnGoing Trip detail failed', 'Error!')
            })
        },
        getSite(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            //params.roleRank = 4;
            let siteList = [];
            this.$siteDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        siteList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.siteName,
                                
                            }
                        })
                       
                    }
                    this.site_name = siteList;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('site.requestFunction-error:', error)
                    this.$snotify.error('Get site list failed', 'Error!')
                })
        },
        updateTrip () {
            this.loading = true;
            this.tripException = {
                ...this.tripException,
                recordedTime : new Date().toISOString()
            }
            return tripExceptionService.addtripException(this.tripException)
            .then((response) => {
                console.log("responseeeee",response)
                this.loading = false
                this.flash = false
                this.tripUpdateDone()
                
            })
            .catch(error => {
                this.loading = false
                this.$snotify.error('Destination update failed', 'Error!')
            })
            
        },
        tripUpdateDone(){
            this.trip.endSite = this.tripException.divertedDestination
            this.loading = true;
            this.trip = {
                ...this.trip,
                endSite : this.tripException.divertedDestination
            }
            return tripService.updateTrip(this.trip)
                .then((response) => {
                    this.loading = false
                    this.flash = false
                    this.$snotify.success('Destination has been updated!', 'Success!')
                    this.$router.push('/trip')
                })
        },
         fieldClassName: function (field) {
            if(!field) {
                return '';
            }
            if((field.$touched || field.$submitted) && field.$valid) {
                return 'has-success';
            }
            if((field.$touched || field.$submitted) && field.$invalid) {
                return 'has-danger';
            }
        },
        
        created() {
        const promises = []
        this.loading = true
        promises.push(this.getTrip())
        Promise.all(promises)
            .then(() => {
                this.loading = false
                this.ready = true
            })
            .catch(() => {
                this.loading = false
            })
    }
    }
    
}
</script>

<style scoped>
    .required-field > label::after  {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    .gradientbt{
        background: #0F6940;
        color: white
    }
    .box-header{
        background: #0F6940;
        color: white
    }
</style>



                        







// WEBPACK FOOTER //
// UpdateDestination.vue?4abe21ce